import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";

import AutoLoginHandler from "../components/AutoLoginHandler";
import { MAIN_SCROLL_CONTAINER_ID } from "../components/ScrollToTop";
import CreditMigrationModal from "../components/CreditMigrationModal";
import PostAuthCatalogHydration from "../components/PostAuthCatalogHydration";
import { useIsMobileApp } from "../hooks/useIsMobileApp";

export default function MainLayout() {
  const isMobileApp = useIsMobileApp();
  const safeAreaPadding = isMobileApp ? 0 : 0;

  return (
    <>
      <AutoLoginHandler />
      <PostAuthCatalogHydration />
      <CreditMigrationModal />
      <Box
        sx={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
          paddingTop: safeAreaPadding,
        }}
      >
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            alignItems: "stretch",
            overflow: "hidden",
          }}
        >
          <Box
            id={MAIN_SCROLL_CONTAINER_ID}
            sx={{
              flex: 1,
              width: "100%",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <Box
              sx={{
                flex: 1,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                "& > *": {
                  position: "relative",
                },
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
